import { GET_COUNTRIES } from '../graphql/queries/getCountries';
import { GET_STATES } from '../graphql/queries/getStates';
import { store } from '../index';
import { SET_COUNTRIES, SET_STATES } from './types';
import { history } from '../components/App';

/**
 * Get Countries
 * 
 * @param {object} client - Apollo client
 */
export async function GetCountries(client){
    try{
        const response = await client.query({query:GET_COUNTRIES});    
        await store.dispatch({ type:SET_COUNTRIES, payload:response.data.getCountries});
        return response;
    }
    catch({graphQLErrors}){
        if(graphQLErrors !== undefined){
            const hasResponseUrl = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.url : "";
            const hasReponseStatus = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.status : "";
            console.error(`${graphQLErrors[0].message} : ${hasResponseUrl}`);
            if(hasReponseStatus === 500) history.push("/500");
            return graphQLErrors[0].message;
        }
    } 
}



export async function GetState(client){
    try{
        const response = await client.query({query:GET_STATES});    
        await store.dispatch({ type:SET_STATES , payload:response.data.getStates});
        return response;
    }
    catch({graphQLErrors}){
        if(graphQLErrors !== undefined){
            const hasResponseUrl = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.url : "";
            const hasReponseStatus = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.status : "";
            console.error(`${graphQLErrors[0].message} : ${hasResponseUrl}`);
            if(hasReponseStatus === 500) history.push("/500");
            return graphQLErrors[0].message;
        }
    } 
}
